document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form#create_customer');
    const professionSelect = document.getElementById('customer_tag');
    const sellerSelect = document.getElementById('seller_tag');
    const b2bHiddenField = document.getElementById('b2b_tag'); // Campo nascosto per B2B
    const fidelityCheckbox = document.getElementById('fidelity_card');
    const whatsappCheckbox = document.getElementById('whatsapp_group');
    const customerTagsField = document.getElementById('customer_tags');

    form.addEventListener('submit', function () {
        let tags = [];

        // Aggiungi il tag della professione se selezionato
        if (professionSelect && professionSelect.value) {
            tags.push(professionSelect.value);
        }

        // Aggiungi il tag del rappresentante se selezionato
        if (sellerSelect && sellerSelect.value) {
            tags.push(sellerSelect.value);
        }

        // Aggiungi il tag della fedeltà se il checkbox è selezionato
        if (fidelityCheckbox && fidelityCheckbox.checked) {
            tags.push(fidelityCheckbox.value);
        }

        // Aggiungi il tag WhatsApp se il checkbox è selezionato
        if (whatsappCheckbox && whatsappCheckbox.checked) {
            tags.push(whatsappCheckbox.value);
        }

        // Aggiungi automaticamente il tag "B2B" se il campo nascosto lo prevede
        if (b2bHiddenField && b2bHiddenField.value) {
            tags.push(b2bHiddenField.value);
        }

        // Inserisci i tag concatenati nel campo nascosto
        customerTagsField.value = tags.join(', ');

        console.log('Tags inviati:', customerTagsField.value); // Debug per verificare
    });
});
